import React from 'react';
import s from './styles.module.css'
import Wrapper from '../../components/wrapper';
import HeaderTitle from '../../components/header_title';

const PrivacyPolicy = () => {
  return (
    <div className={s.main}>
      <Wrapper>
        <HeaderTitle/>
        <h1>Privatlivspolitik</h1>

        <p>
          Vi respekterer dit privatliv og behandler dine personoplysninger i
          overensstemmelse med gældende databeskyttelseslovgivning. Denne
          privatlivspolitik forklarer, hvilke oplysninger vi kan indsamle, og
          hvordan de anvendes.
        </p>

        <h2>Hvilke oplysninger indsamler vi?</h2>
        <p>
          Når du besøger hjemmesiden, kan vi automatisk indsamle tekniske
          oplysninger såsom IP-adresse, browsertype, operativsystem,
          henvisende hjemmeside og oplysninger om, hvordan hjemmesiden bruges.
        </p>

        <h2>Cookies</h2>
        <p>
          Hjemmesiden kan anvende cookies for at forbedre brugeroplevelsen,
          analysere trafik og sikre korrekt funktionalitet. Du kan til enhver
          tid administrere eller slette cookies via indstillingerne i din browser.
        </p>

        <h2>Anvendelse af oplysninger</h2>
        <p>
          De indsamlede oplysninger bruges til at forbedre hjemmesidens
          funktionalitet, analysere besøgsstatistik og udvikle vores indhold
          og tjenester.
        </p>

        <h2>Links til tredjeparter</h2>
        <p>
          Hjemmesiden indeholder links til eksterne långivere og andre
          tredjepartswebsteder. Vi er ikke ansvarlige for indholdet eller
          privatlivspolitikken på disse hjemmesider. Vi anbefaler, at du læser
          deres privatlivspolitik, inden du afgiver personoplysninger.
        </p>

        <h2>Videregivelse af oplysninger</h2>
        <p>
          Vi sælger eller udlejer ikke dine personoplysninger til tredjeparter.
          Oplysninger kan kun videregives, hvis det er påkrævet i henhold til
          gældende lovgivning.
        </p>

        <h2>Datasikkerhed</h2>
        <p>
          Vi træffer rimelige tekniske og organisatoriske foranstaltninger for
          at beskytte oplysninger mod uautoriseret adgang, tab eller misbrug.
        </p>

        <h2>Dine rettigheder</h2>
        <p>
          I henhold til gældende databeskyttelsesregler kan du have ret til at
          anmode om indsigt i, rettelse eller sletning af dine personoplysninger,
          hvis vi behandler sådanne oplysninger.
        </p>

        <h2>Ændringer af privatlivspolitikken</h2>
        <p>
          Vi forbeholder os retten til at opdatere denne privatlivspolitik.
          Eventuelle ændringer offentliggøres på denne side og træder i kraft
          fra offentliggørelsesdatoen.
        </p>
      </Wrapper>
    </div>
  );
};

export default PrivacyPolicy;
